/* eslint-disable react-hooks/exhaustive-deps */
import UnlockPoints from "../../Components/UnlockPoints/UnlockPoints";
import TrendingGiftCards from "../../Components/TrendingGiftCard/TrendingGiftCards";
//import TopSellingBrands from "../../Components/TopSellingBrands/TopSellingBrands";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { trackEvent } from "../../Components/Utility/Utility";
import { onGetAddSpecial } from "../../Store/Slices/addSpecialListSlice";
import { onGetofferMaster } from "../../Store/Slices/offerMasterSlice";
import { fetchHomepageLayout } from "../../Store/Slices/homepageLayoutSlice";
import { onStaticPointsSubmit } from "../../Store/Slices/staticPointSlice";
import ShopByCategoryOptimized from "../../Components/shopByCategory/ShopByCategoryOptimized";
import SessionExpiredModal from "../SessionExpired/SessionExpiredModal";
import OfferBanner from "../../Components/OfferBanner/OfferBanner";
import UnlockPointsLuxury from "../../Components/UnlockPointsLuxury/UnlockPointsLuxury";
const defaultDesktopSliderSettings = {
  slidesToShow: 2,
  slidesToScroll: 2,
  autoplay: true,
  autoplaySpeed: 3000,
  infinite: true,
  arrows: false,
  dots: true,
  speed: 3000,
  pauseOnHover: true,
};

const defaultMobileSliderSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  infinite: true,
  arrows: false,
  dots: true,
  speed: 3000,
  pauseOnHover: true,
};
const homepageComponentNames = new Set([
  "OfferBanner",
  "UnlockPoints",
  "ShopByCategoryOptimized",
  "TrendingGiftCards",
  "UnlockPointsLuxury"
]);

const fallbackLayout = [
  { id: "OfferBanner", component: "OfferBanner", placement: "Main" },
  { id: "OfferBanner2", component: "OfferBanner", placement: "Bottom" },
  { id: "OfferBanner3", component: "OfferBanner", placement: "Middle" },
  { id: "unlockPoints", component: "UnlockPoints" },
  { id: "shopByCategory", component: "ShopByCategoryOptimized" },
  { id: "trendingGiftCards", component: "TrendingGiftCards" },
];

const getSectionSettingsMap = (sliderSettingsFromConfig) =>
  sliderSettingsFromConfig?.offerBannerSettings ||
  sliderSettingsFromConfig?.offerBanners ||
  sliderSettingsFromConfig?.sections ||
  {};

const getSectionSettings = (sliderSettingsFromConfig, id, placement) => {
  const sections = getSectionSettingsMap(sliderSettingsFromConfig);
  const normalizedPlacement = (placement || "").toLowerCase();

  return (
    sections?.[id] ||
    sections?.[placement] ||
    sections?.[normalizedPlacement] ||
    {}
  );
};

const resolveBannerSliderProps = ({
  sliderSettingsFromConfig,
  id,
  placement,
  props,
}) => {
  const sectionSettings = getSectionSettings(sliderSettingsFromConfig, id, placement);

  const resolvedDefaultDesktopSettings = {
    ...defaultDesktopSliderSettings,
    ...(sliderSettingsFromConfig?.defaultDesktopSetting || {}),
    ...(sectionSettings?.defaultDesktopSetting || {}),
    ...(props?.defaultDesktopSliderSettings || {}),
  };

  const resolvedDefaultMobileSettings = {
    ...defaultMobileSliderSettings,
    ...(sliderSettingsFromConfig?.defaultMobileSetting || {}),
    ...(sectionSettings?.defaultMobileSetting || {}),
    ...(props?.defaultMobileSliderSettings || {}),
  };

  const resolvedDesktopSettings = {
    ...(sliderSettingsFromConfig?.desktopSetting || {}),
    ...(sectionSettings?.desktopSetting || sectionSettings?.desktopSettings || {}),
    ...(props?.desktopSettings || {}),
  };

  const resolvedMobileSettings = {
    ...(sliderSettingsFromConfig?.mobileSetting || {}),
    ...(sectionSettings?.mobileSetting || sectionSettings?.mobileSettings || {}),
    ...(props?.mobileSettings || {}),
  };

  return {
    desktopSettings: resolvedDesktopSettings,
    mobileSettings: resolvedMobileSettings,
    defaultDesktopSliderSettings: resolvedDefaultDesktopSettings,
    defaultMobileSliderSettings: resolvedDefaultMobileSettings,
  };
};

const getRenderableLayout = (layout) => {
  if (!Array.isArray(layout) || layout.length === 0) return null;

  const items = layout
    .filter(
      (item) =>
        item?.enabled !== false && homepageComponentNames.has(item?.component)
    )
    .sort((a, b) => {
      const first = Number.isFinite(Number(a?.displayOrder)) ? Number(a.displayOrder) : Number.MAX_SAFE_INTEGER;
      const second = Number.isFinite(Number(b?.displayOrder)) ? Number(b.displayOrder) : Number.MAX_SAFE_INTEGER;
      return first - second;
    });

  return items.length ? items : null;
};

const HomePage = () => {
  const [sessionExpired, setSessionExpired] = useState(false);
  const dispatch = useDispatch();
  const hasRequestedTrendingData = useRef(false);
  const hasRequestedOfferData = useRef(false);
  const hasRequestedStaticPoints = useRef(false);
  const hasLoginData = useSelector(
    (state) => Boolean(state.loginAuthReducer?.data?.length)
  );
  const hasTrendingData = useSelector((state) =>
    Array.isArray(state.addSpecialReducer?.getData)
  );
  const clientTitle = useSelector(
    (state) => state.clientDataReducer?.title
  );
  const configClient = clientTitle?.trim().toLowerCase();
  const configuredLayout = useSelector(
    (state) => state.homepageLayoutReducer?.layout
  );
  const homepageLayoutStatus = useSelector(
    (state) => state.homepageLayoutReducer?.status
  );
  const renderableLayout = getRenderableLayout(configuredLayout);
  const homepageLayout = homepageLayoutStatus === "succeeded" && renderableLayout
    ? renderableLayout
    : fallbackLayout;
  const [sliderSettingsFromConfig, setSliderSettingsFromConfig] = useState({});
  useEffect(() => {
    document.body.classList.remove("no-scroll");
    trackEvent("page_browse", {
      page_title: "Home Page",
      page_url: window.location.href,
    });
    if (sessionStorage.getItem("sessionExpired") === "true") {
      setSessionExpired(true);
      sessionStorage.setItem("blockDirectUrl", true)
      sessionStorage.removeItem("sessionExpired");
      setTimeout(() => {
        sessionStorage.removeItem("blockDirectUrl");
      }, 1000);
    }
  }, []);
  useEffect(() => {
    let isMounted = true;

    const loadSliderSettings = async () => {
      if (!clientTitle) return;
      try {
        const response = await fetch(`/customConfig/${configClient}/sliderSetting.json`, {
          cache: "no-store",
        });
        if (!response.ok) return;
        const config = await response.json();
        if (isMounted && config && typeof config === "object") {
          setSliderSettingsFromConfig(config);
        }
      } catch {

      }
    };

    loadSliderSettings();

    return () => {
      isMounted = false;
    };
  }, [clientTitle]);

  const dispatchOnce = (ref, action) => {
    if (hasLoginData && !ref.current) {
      ref.current = true;
      dispatch(action());
    }
  };

  useEffect(() => {
    dispatchOnce(hasRequestedTrendingData, onGetAddSpecial);
    dispatchOnce(hasRequestedOfferData, onGetofferMaster);
    dispatchOnce(hasRequestedStaticPoints, onStaticPointsSubmit);
  }, [dispatch, hasLoginData]);

  useEffect(() => {
    if (configClient) dispatch(fetchHomepageLayout(configClient));
  }, [configClient, dispatch]);

  const renderLayoutItem = (item, index) => {
    const { id, component, displayOrder, enabled, ...props } = item;
    const key = id || `${component}-${index}`;
    switch (component) {
      case "OfferBanner":
        {
          const normalizedPlacement = props.placement || "Main";
          const normalizedPrefix = normalizedPlacement?.toLowerCase() === "main" ?
            "top_banner" : normalizedPlacement?.toLowerCase() === "bottom"
              ? "bottom_banner" : "middle_banner";
          const sliderProps = resolveBannerSliderProps({
            sliderSettingsFromConfig,
            id,
            placement: normalizedPlacement,
            props,
          });
          return <OfferBanner key={key} placement={normalizedPlacement} {...props} promotionPrefix={normalizedPrefix}
            imageKey="image"
            interval={6000}
            wrapperClassName="mainDiv desktop_hero_slider"
            wrapperId={`imageSection_${normalizedPrefix}`}
            sectionClassName="py-xl-4 mt-3 pt-2 earn"
            rowClassName="row m-xl-n3 m-md-n2 m-n1 mt-4"
            columnClassName="col-lg-6 col-12"
            imageClassName="d-block w-100 imgSec_H"
            dotContainerClassName="dots-container"
            desktopSettings={sliderProps.desktopSettings}
            mobileSettings={sliderProps.mobileSettings}
            defaultDesktopSliderSettings={sliderProps.defaultDesktopSliderSettings}
            defaultMobileSliderSettings={sliderProps.defaultMobileSliderSettings} />;
        }

      case "UnlockPoints":
        return <UnlockPoints key={key} {...props} />;
      case "UnlockPointsLuxury":
        return <UnlockPointsLuxury key={key} {...props} />;
      case "ShopByCategoryOptimized":
        return <ShopByCategoryOptimized key={key} {...props} />;

      case "TrendingGiftCards":
        return <TrendingGiftCards key={key} {...props} />;

      // case "TopSellingBrands":
      //   return <TopSellingBrands key={key} {...props} />;

      // PromotionalStrip is rendered by DesktopHeader/MobileHeader.
      case "PromotionalStrip":
      default:
        return null;
    }
  };

  return (
    <>
      <SessionExpiredModal
        isOpen={sessionExpired}
        onClose={() => {
          setSessionExpired(false);
        }}
      />
      {homepageLayout.map(renderLayoutItem)}
    </>
  );
};

export default HomePage;
